import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { format } from "date-fns";
import {
  Card,
  CardSection,
  Stack,
  Text,
  Box,
  Button,
  Heading,
  Separator,
  Loading,
} from "@kiwicom/orbit-components";

// Utils
import { getBlogPosts } from "../../utils/api/blog";
// Components
import Wrapper from "../../components/Content";
import { Container } from "../../components/Content/styles";
// Types
import { Blog as BlogType } from "../../static/types/blog";
// Utils
import translate from "../../utils/translate";

// Styles
import { Content, BlogImage, BlogLink } from "./Styled";

const Blog = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [posts, setPosts] = useState<BlogType[]>([]);

  useEffect(() => {
    // Fetchs blog posts
    getBlogPosts(setPosts, setLoading);
  }, []);

  return (
    <Wrapper>
      <Helmet>
        <title>{translate("navigation.menu.blog")}</title>
      </Helmet>
      <Content>
        <Container animate>
          <Stack>
            <Box
              padding={{ left: "medium", right: "medium" }}
              tablet={{ padding: { left: "none", right: "none" } }}
            >
              <Heading as="h1">{translate("navigation.menu.blog")}</Heading>
            </Box>
            <Card>
              {loading && <Loading type="pageLoader" />}
              {posts.length &&
                posts.map((post: BlogType) => (
                  <CardSection key={post.id}>
                    <BlogLink href={`/blog/${post.id}`}>
                      <Stack
                        direction="column"
                        // align="center"
                        tablet={{ direction: "row" }}
                      >
                        <BlogImage
                          url={`${process.env.REACT_APP_STORAGE_BASE}/blog-thumb/${post.image}`}
                        />
                        <Stack spacing="XSmall">
                          <Text size="small" type="secondary">
                            {format(new Date(post.created_at), "PPP")}
                          </Text>
                          <Heading
                            as="h3"
                            type="title2"
                            tablet={{ type: "title1" }}
                          >
                            {post.title}
                          </Heading>
                          <Separator />
                          <Text>
                            <div
                              dangerouslySetInnerHTML={{ __html: post.thumb }}
                            />
                          </Text>
                          <Button size="small">
                            {translate("global.see_more")}
                          </Button>
                        </Stack>
                      </Stack>
                    </BlogLink>
                  </CardSection>
                ))}
            </Card>
          </Stack>
        </Container>
      </Content>
    </Wrapper>
  );
};

export default Blog;
